import { AxiosInstanceProvider } from '../../../../core/hooks';
import { ChartSettings } from '../../../chart-settings/model';
import { CpeMonitoredDevicesQuery } from '../../config';
import { DeviceAvailabilityMeasurementModel } from '../../model';

interface GetAvailabilityMeasurementsPayloadModel {
  customerId: number;
  deviceId: string;
  chartSettings: ChartSettings;
}

export const getAvailabilityMeasurements = async (
  axios: AxiosInstanceProvider,
  { customerId, deviceId, chartSettings }: GetAvailabilityMeasurementsPayloadModel,
): Promise<DeviceAvailabilityMeasurementModel[]> => {
  const url = CpeMonitoredDevicesQuery['GetAvailabilityMeasurements'].url
    .replace('{customerId}', customerId.toString(10))
    .replace('{deviceId}', deviceId);
  const requestConfiguration = {
    params: {
      timespan: chartSettings.timespan,
      resolution: chartSettings.resolution,
    }
  };
  const response = await axios().get<DeviceAvailabilityMeasurementModel[]>(url, requestConfiguration);
  return response.data;
};